/**
 * Cart Drawer Upsell Add to Cart Functionality
 * Simple function to add products to cart from the upsell section
 * without visual feedback or additional functionality
 */

window.addUpsellToCart = function(variantId) {
  // Only perform the AJAX call to add to cart, with no visual feedback
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    })
  })
  .then(response => response.json())
  .then(data => {
    // Only dispatch the event to refresh the cart
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      })
    );
    
    // Refresh cart if that function exists
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  });
  
  return false; // Prevent default action
};
